import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Email from 'shared/ui/icons/Email';

import {PALETTE} from 'shared/config/model/palette';
import {brandColor} from 'shared/lib/colors';

import styles from './Profile.module.scss';

const ChangeEmailButton: React.FC = () => {
    return (
        <div className={styles.reset}>
            <div className={cn(
                styles.action,
                styles.colorText,
            )}>
                <Email color={brandColor(PALETTE.accent, PALETTE.accentEn)} />
                {t`Изменить E-mail`}
            </div>
            <p className={styles.text}>
                {t`Для операции необходимо повторно ввести пароль и подтвердить адрес.`}
            </p>
        </div>
    );
};

export default ChangeEmailButton;